import Cookies from 'js-cookie';
import GeoPointInput from './geo_point_input';

export default class FormObject {
	constructor(form) {
		this.form = form;
		this.form.form_object = this;
		this.sumbitting = false;
		this.geo_points = [];
		
		if (this.form.analytics && this.form.analytics.eventHandler) {
			this.form.removeEventListener('submit', this.form.analytics.eventHandler);
		}

		this.form.addEventListener('submit', event => {
			event.preventDefault();
			event.stopImmediatePropagation();
			if (!this.sumbitting) {
				// Custom confirm functionality
				if (this.form.dataset.confirm) {
					const result = window.confirm(this.form.dataset.confirm);
					if (!result) return false;
				}

				this.submitting_toggle(true);

				if (event.submitter && event.submitter.matches('button[name]')) {
					const hidden_input = document.createElement('input');
					hidden_input.type = 'hidden';
					hidden_input.value = event.submitter.value;
					hidden_input.name = event.submitter.name;
					this.form.appendChild(hidden_input);
				}

				new Promise((resolve, reject) => this.validate(resolve, reject))
					.then(
						() => {
							if (
								this.form.analytics &&
									this.form.analytics.data.event == 'submit'
							) {
								this.form.analytics.send(() => this.form.submit());
							} else {
								this.form.submit();
							}
						},
						() => this.submitting_toggle(false)
					);
			}
		});
	}

	submitting_toggle(expression) {
		this.sumbitting = expression;
		this.form.classList.toggle('submitting', expression);
	}

	add_geo_point(geo_point) {
		if (this.geo_points.size < 1) {
			this.form.addEventListener('GeoPoint updated', event => {
				this.form.classList.toggle(
					'forbidden',
					this.geo_points
						.reduce((memo, input) => memo || input.forbidden, false)
				);
			});
		}

		this.geo_points.push(geo_point);
	}

	validate(success_callback = () => {}, failure_callback = () => {}) {
		const promises = this.geo_points.map(geo_point_input => {
			return new Promise((resolve, reject) => {
				geo_point_input._update_coordinates({ force: true }, resolve);
			});
		});

		return Promise.all(promises).then(() => {
			// Coordinates not found for any geo point input
			const first_invalid_geo_point_input = this.geo_points.find(input => {
				return !input.valid();
			});
			if (first_invalid_geo_point_input) {
				first_invalid_geo_point_input.visible_input.focus();
				failure_callback();
			} else {
				success_callback();
			}
		});
	}

	direction_completed() {
		if (this.geo_points.length < 2) return false;

		return this.geo_points.every(geo_point => {
			return geo_point.address;
		});
	}
}
